export const oracleAnswers = {
  // --- NECESSIDADES ---
  necessidade_0_30: [
    "O Oráculo consultou os astros e eles disseram: 'Compre, mas se não anotar no app, o porquinho morre'.",
    "O Oráculo viu que {name} custa só {price} e deixou passar. Vá em paz.",
    "Se {name} resolve sua vida por esse valor, o Oráculo aprova com um sorriso.",
    "R$ {price} em algo necessário? Nem o Oráculo discute. Pode comprar.",
    "Pequeno, útil e necessário. {name} é um combo raro, aproveita.",
    "O orçamento aguenta {name}, só não faz disso um hábito de toda hora.",
    "Se resolve sua vida por R$ {price}, o Oráculo aprova com sorriso.",
    "Isso aqui o orçamento aguenta.",
    "Só não faz disso rotina, combinado?",
    "Cuidado com o efeito dominó.",
    "O Oráculo deu o selo 'Pode Comprar'. Mas se não anotar no Troquinho, o porquinho morre, tá? 🐷",
    "R$ {price} em {name}? Vá em paz, meu filho. O Oráculo não briga por troco."
  
  ],
  necessidade_31_100: [
    "Sobrevivência em primeiro lugar. Mas {name} não tem um cupom de desconto não? 🍎",
    "Necessidade aceita. Mas você pesquisou se {name} estava mais barato em outro lugar?",
    "R$ {price} é um valor ok para {name}, mas anota pra não esquecer!",
    "O Oráculo permite {name}, mas com atenção ao fechamento da fatura.",
    "Pode comprar {name}, mas tente economizar esse valor em outra coisa hoje.",
    "Isso aqui já precisa de consciência.",
    "Pode ir, mas com atenção.",
    "👀 Eu só tô observando…",
    "Resolve, mas não pode ser surpresa de novo.",
    "Pode ir, mas se organiza.",
    "Cuidado com o efeito dominó.",
    "Necessidade aceita. Mas você pesquisou se esse(a) {name} não tava mais barato no vizinho? 👀",
    "Pode comprar, mas tenta compensar esse valor em outra coisa hoje pra equilibrar o cosmos.",
    "O Oráculo sentiu um peso na sua mão. {name} é essencial ou você está romantizando esse boleto?",
    "Você precisava de {name}... mas precisava de um planejamento melhor pra esses {price}, né?"

  ],
  necessidade_101_300: [
    "Se {name} é essencial para sua sobrevivência, o Oráculo permite. Mas nada de luxo amanhã!",
    "R$ {price} já começa a pesar. Você realmente não consegue viver sem {name} essa semana?",
    "Necessidade mesmo ou você está romantizando esse(a) {name}?",
    "Você precisava de {name}... mas podia ter se organizado melhor para esse gasto de {price}.",
    "O Oráculo ficou atento: R$ {price} em {name} exige um ajuste no resto do mês.",
    "Aqui já começa a pesar. Necessidade mesmo?",
    "Você precisava… mas podia ter se organizado.",
    "Já pesquisou preço? Pode ter surpresa boa.",
    "Aqui já vale pensar duas vezes.",
    "O Oráculo ficou atento.",
    "Tá tudo certo. Mas dá pra prever na próxima.",
    "Necessidade sem planejamento vira rotina cara.",
    "O Oráculo sentiu um peso na sua mão. {name} é essencial ou você está romantizando esse boleto?",
    "Você precisava de {name}... mas precisava de um planejamento melhor pra esses {price}, né?"

  ],
  necessidade_301_700: [
    "Se não tem como viver sem {name}, compre. Mas sem fingir que o dinheiro cai do céu. ✅",
    "Comprar {name} por {price} é uma decisão séria. O Oráculo espera que seja essencial mesmo.",
    "Não é um gasto pequeno, então trate {name} com o respeito que seu dinheiro merece.",
    "Seu orçamento pediu respeito antes de você passar esses {price} em {name}.",
    "O Oráculo aceita, mas avisa: {price} em {name} vai fazer falta no lazer do final de semana.",
    "Isso aqui não pode ser no improviso. {name} estava no seu planejamento?",
    "Aqui já começa a pesar. Necessidade mesmo?",
    "Não é pequeno, então trate como não pequeno.",
    "Aqui já não é brincadeira.",
    "Aqui já é vida adulta acontecendo.",
    "Isso aqui não pode ser no improviso.",
    "Seu orçamento pediu respeito.",
    "Necessidade sem planejamento vira rotina cara.",
    "Isso aqui já é vida adulta de alto nível. O Oráculo autoriza, mas pede silêncio e reflexão na fatura."
  ],
  necessidade_701_1500: [
    "R$ {price} é um valor que exige planejamento, oração e avaliar se é realmente necessario",
    "Não é pequeno, então trate como grande.",
    "Necessidade com peso estrutural.",
    "Isso aqui mexe no mês inteiro.",
    "Aqui não tem espaço pra improviso.",
    "Já pesquisou preço? Pode ter surpresa boa.",
    "Isso aqui já mexe no seu planejamento.",
    "Necessidade com responsabilidade total.",
    "R$ {price} em {name} exige planejamento, oração e uma conferida no saldo total.",
    "O Oráculo viu o peso estrutural de {name} no seu mês. Tem certeza que é agora?",
    "Gastar {price} mexe no seu planejamento inteiro. {name} é prioridade máxima?",
    "Isso aqui já não é brincadeira. {name} vai comprometer outros boletos?",
    "O Oráculo autoriza com uma dor no coração por esses {price}.",
    "O Oráculo deu o selo de 'Coragem'. Gastar {price} em {name} não é para amadores. Reze um boleto nosso."
  ],
  necessidade_1501_3000: [
    "Aqui já é necessidade de alto impacto, tem certeza?",
    "Seu orçamento precisa se reorganizar.",
    "Isso cabe no mês sem sufoco?",
    "Tem opção mais barata que resolve igual?",
    "Necessidade de alto impacto.",
    "Parabéns por resolver. Agora vamos evitar o próximo?",
    "Já entra no modo “controle total”.",
    "R$ {price}?! O Oráculo sentiu um tremor no seu CPF só de ler {name}.",
    "Seu orçamento precisa se reorganizar urgentemente após esse gasto com {name}.",
    "Tem alguma opção de {name} mais barata que resolve igual por menos de {price}?",
    "Necessidade de alto impacto detectada. O Oráculo está em modo de alerta.",
    "O Oráculo deu o selo de 'Coragem'. Gastar {price} em {name} não é pra amadores.",
    "Isso aqui é um evento canônico no seu extrato. {name} por esse valor muda o seu ano (e o seu saldo)."

  ],
  necessidade_plus_3000: [
    "Aqui não tem espaço pra erro.",
    "Isso aqui resolve. Mas seu planejamento pediu demissão.",
    "Seu bolso aceitou. Seu controle pediu revisão.",
    "Necessidade de alto impacto.",
    "Isso aqui é manutenção da vida… não surpresa.",
    "Isso aqui já é planejamento de verdade.",
    "Já entra no modo “controle total”.",
      "🚨 ALERTA DE ROMBO! 🚨 {price} em {name} exige uma reunião de emergência com o seu bolso.",
    "Isso aqui é nível estratégico. {name} por esse valor muda o seu ano.",
    "Seu planejamento pediu demissão depois que você digitou {price} para {name}.",
    "O Oráculo está em silêncio absoluto diante desse valor por {name}.",
    "Isso aqui é manutenção da vida ou um evento canônico no seu extrato?",
    "Isso aqui é um evento canônico no seu extrato. {name} por esse valor muda o seu ano (e o seu saldo)."

  ],

  // --- SUPÉRFLUOS ---
  superfulo_0_30: [
    "R$ {price} não dói. A repetição sim.",
    "Só não faz disso rotina, combinado?",
    "R$ {price} aqui, R$ {price} ali…",
    "O Oráculo levantou uma sobrancelha.",
    "Cuidado com o efeito dominó.",
    "Pequeno agora, gigante somado.",
    "Pequeno gasto, grande talento pra se multiplicar.",
    "O problema é o conjunto da obra.",
    "Vai beber uma água. Às vezes é só sede mesmo",
    "Você falou “só hoje”… e a história sempre começa assim.",
    "Eu não tô brava, só decepcionada com esse gasto.",
    "Não julgo… mas julgo um pouco.",
     "Um mimo de {price} não mata ninguém, mas dez mimos desses matam o seu mês. Cuidado.",
    "R$ {price} em {name} não dói hoje. O arrependimento na fatura sim.",
    "Você quer {name} ou só quer gastar dinheiro? O Oráculo sabe a resposta.",
    "R$ {price} aqui, R$ {price} ali... e cadê o seu dinheiro no fim do mês?",
    "Vai beber uma água. Às vezes a gente confunde sede com vontade de comprar {name}.",
    "Vai beber uma água. Às vezes a gente confunde sede com vontade de comprar {name}. 💧",
"R$ {price} não dói. O problema é que você faz isso dez vezes por semana. O Oráculo está de olho.",
"Um mimo de {price} não mata ninguém, mas o conjunto da obra mata o seu mês. Cuidado."
  ],
  superfulo_31_100: [
    "Mais um capítulo da série “não precisava”.",
    "Isso aqui é traiçoeiro.",
    "Como pode R$30 + R$30 dar R$2000 na fatura? Mistério nacional.",
    "Seu bolso tá tipo: “do nada isso aqui?”",
    "Respeito pela coragem, preocupação pela consistência.",
    "O Oráculo anotou. E não foi com alegria.",
    "“Eu mereço”… mas o saldo também merece paz.",
    "Seu extrato vai comentar isso depois.",
    "Espera 10 minutos. Se ainda quiser, aí a gente conversa.",
    "Isso aqui daria um episódio inteiro de The Office… e ninguém ia te defender",
    "Eu não tô brava, só decepcionada com esse gasto.",
    "Não julgo… mas julgo um pouco.",
     "Bebe uma água. Às vezes a gente confunde carência com vontade de comprar {name}.",
    "Mais um capítulo da série: 'coisas que eu não precisava, mas comprei por {price}'.",
    "Como pode R$ {price} em {name} parecer pouco e depois virar um monstro na fatura?",
    "“Eu mereço”... o problema é que seu saldo não merece esse gasto em {name}.",
    "Espera 10 minutos. Se ainda quiser {name} por {price}, aí a gente conversa.",
    "Mais um capítulo da série: 'Coisas que eu não precisava, mas comprei por {price}'. 🎬",
"Eu não estou brava, estou decepcionada. {name} por esse valor? Repense sua existência.",
"Espera 10 minutos. Se ainda quiser gastar esses {price}, o problema já é espiritual."
  ],
  superfulo_101_300: [
    "Status: O Oráculo está te julgando em 4K por querer {name}.",
    "Aqui já não é só vontade, é decisão. E escolha tem consequência.",
    "Você chamou de vontade. O banco chamou de erro.",
    "Aqui mora o perigo.",
    "Seu eu do futuro já deu uma suspirada.",
    "Seu bolso ficou em silêncio… e isso é preocupante.",
    "Seu eu do futuro já mandou um “sério isso?”.",
    "Mais um passo pro “como cheguei nisso?”",
    "Olha sua fatura antes. Só por esporte.",
    "Essa decisão foi tão errada que merecia trilha sonora triste de novela.",
    "Autocuidado ou autossabotagem premium?",
    "Não julgo… mas julgo um pouco.",
    "Status: O Oráculo está te julgando em 4K por querer gastar {price} em {name}.",
    "Você chamou de vontade. O banco chamou de 'erro 404: saldo não encontrado'.",
    "Seu eu do futuro mandou um 'Sério mesmo que você vai gastar {price} com {name}?'",
    "R$ {price} em {name}? Isso daria um belo aporte em investimentos, né?",
    "Autocuidado ou autossabotagem premium gastando esse valor em {name}?",
    "Status: O Oráculo está te julgando em 4K. R$ {price} em {name} é puro suco de impulso.",
"Você chamou de vontade. O seu banco chamou de 'Erro 404: Dignidade não encontrada'.",
"Essa decisão foi tão errada que merecia trilha sonora triste de novela. {price}? Sério?"
  ],
  superfulo_301_700: [
    "R$ {price} é um valor que exige planejamento, oração e talvez um 'não'.",
    "Respira. Ainda dá tempo de voltar.",
    "Não é impulso. É escolha emocional cara.",
    "Seu eu do futuro ficou desconfortável.",
    "O Oráculo ficou preocupado.",
    "Você chamou de vontade. - O banco chamou de ousadia.",
    "Respira. Nem todo desejo precisa virar boleto.",
    "Espera 24h. Se for amor, ele sobrevive.",
    "Olha seu saldo antes de decidir com emoção.",
    "Faz a conta: quantas horas de trabalho é isso?",
    "Isso aqui é plot twist financeiro.",
    "🤡 Você falou “mereço” com uma convicção perigosa.",
    "R$ {price} em {name} exige planejamento, oração e talvez um 'não' bem grande.",
    "Não é impulso, é uma escolha emocional bem cara. {name} vale seu suor?",
    "Faz a conta: quantas horas você trabalhou para pagar esse(a) {name} de {price}?",
    "Nem todo desejo precisa virar boleto. Deixa {name} para o mês que vem.",
    "🤡 Você falou 'mereço {name}' com uma convicção perigosa para quem tem boletos.",
    "🤡 Você falou 'eu mereço' com uma convicção perigosa. O seu saldo não concorda com {name}.",
"Faz a conta: quantas horas de trabalho esse(a) {name} de {price} vai te custar? Vale o suor?"
  ],
  superfulo_701_1500: [
    "O Oráculo viu o futuro e você estava pedindo dinheiro emprestado no grupo da família por causa de {name}.",
    "Aqui já entra no modo “tem certeza MESMO?",
    "Isso aqui já exige explicação interna. Ou terapia leve depois",
    "Respira antes de confirmar.",
    "Dá uma segurada hoje, decide amanhã.",
    "Nem tudo que brilha precisa ser seu.",
    "Dorme uma noite antes. Sério.",
    "Isso aqui não é sobre querer. É sobre perder controle.",
    "Coragem ou teimosia? Fica a reflexão.",
    "🤡 Você não caiu no golpe. Você foi com vontade.",
    "🪦 Aqui jaz o orçamento do mês. Viveu pouco, mas intensamente.",
    "🏠 Essa aí nem o pai do Chris aprovaria.",
    "Coerência passou longe.",
     "O Oráculo previu: se comprar {name} por {price}, vai pedir dinheiro emprestado no grupo da família.",
    "Dorme uma noite antes de entregar {price} para comprar {name}. Sério.",
    "Isso aqui não é sobre querer {name}. É sobre perder o controle da sua dignidade.",
    "Coragem ou teimosia? Gastar {price} em {name} agora parece loucura.",
    "🏠 Nem o pai do Chris aprovaria você gastando {price} com isso.",
    "🏠 Nem o pai do Chris aprovaria você gastando {price} com isso. O Oráculo está em choque.",
"O Oráculo previu: se comprar {name} agora, vai passar o resto do mês comendo miojo e tristeza."

  ],
  superfulo_1501_3000: [
    "🚨 ALERTA DE ROMBO! 🚨 Com esse valor a gente comprava 3 meses de dignidade.",
    "O Oráculo ficou em silêncio.",
    "Seu saldo acabou de sair do chat.",
    "R$ {price}? O Oráculo pediu água.",
    "Isso aqui já é nível “tem certeza absoluta?”",
    "Você chamou de vontade, O banco chamou de ousadia extrema.",
    "Pergunta pra você mesma: é vontade ou carência?",
    "Coragem ou teimosia? Fica a reflexão.",
    "Seu cérebro: “mereço”. Seu bolso: “não aguento mais”.",
    "Atenção: seu eu do futuro pediu pra cancelar isso aí.",
    "📢 Comunicado: seu saldo não compactua com essa decisão.",
    "🤡 Você foi feliz por 3 minutos e pobre por 30 dias.",
    "Você quis viver perigosamente.",
   "🚨 ALERTA DE ROMBO! 🚨 Com esses {price} a gente comprava 3 meses de dignidade.",
    "Seu saldo acabou de sair do chat depois que você escreveu '{name}'.",
    "R$ {price} em {name}? O Oráculo pediu um copo de água e um calmante.",
    "Pergunta pra você mesma: é vontade de ter {name} ou é puro surto?",
    "Você foi feliz por 3 minutos com {name} e pobre por 30 dias com a fatura.",
    "🚨 ALERTA DE ROMBO! 🚨 Com esse valor a gente comprava 3 meses de paz mental. Mas você quer {name}.",
"Você foi feliz por 3 minutos com esse(a) {name} e será pobre por 30 dias com a fatura de {price}."
  ],
  superfulo_plus_3000: [
    "R$ {price}?! O Oráculo quase infartou aqui. Respira fundo e pensa de novo.",
    "Isso aqui não é compra. É evento canônico.",
    "🧾 Isso aqui não é compra. É conteúdo pra terapia futura.",
    "Seu saldo não caiu. Ele desistiu.",
    "Seu cérebro: “mereço”. Seu bolso: “não aguento mais”.",
    "Você não precisava disso. Precisava de um suco e silêncio.",
    "🚨 URGENTE: detectamos uma decisão emocional de alto impacto.",
    "🎬 E foi assim que começou mais um capítulo de “onde foi parar meu dinheiro”.",
    "Você virou personagem principal… de um episódio caótico.",
    "Nem roteirista teria coragem de escrever isso.",
    "Seu extrato vai vir em formato de série: várias temporadas.",
    "Me explica esse raciocínio aqui rapidinho.",
    "Você quis viver perigosamente.",
     "R$ {price}?! O Oráculo quase infartou. {name} é feito de ouro ou é só audácia?",
    "Isso aqui não é uma compra de {name}, é um pedido de falência pessoal.",
    "Seu cérebro quer {name}, mas seu bolso está gritando por socorro.",
    "🚨 URGENTE: detectamos uma decisão emocional de {price} com risco de arrependimento.",
    "🎬 E foi assim que começou mais um capítulo de 'Onde foi parar meu dinheiro'.",
    "Isso aqui não é uma compra, é um pedido de socorro. {name} por {price}? O Oráculo pediu demissão.",
"🚨 URGENTE: Detectamos uma decisão emocional de alto risco. Largue o celular e saia de perto da loja!"
  ]
};